import styled from '@emotion/styled'
import { rpMediaQueries } from 'core/theme'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { BoxStore } from 'stores/RussianPoker/Box.store'
import BlackSilverBtn from '../BlackSilverBtn'
import { Typography } from '../Typography'

const ContainerBuyGame = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 5px;
  padding: 3px 4px 0;
  width: 100%;
  white-space: nowrap;

  ${rpMediaQueries.tablet} {
    gap: 10px;
    padding: 6px 6px 0;
  }
`

const DecisionBuyDealerGame: FC<{
  box: BoxStore
}> = observer(({ box }) => {
  const { buyDealerGame, sendBuyDealerGame } = box
  const { t } = useTranslation()

  if (!buyDealerGame.available) return null
  if (buyDealerGame.hasResponded) return null

  return (
    <ContainerBuyGame>
      <BlackSilverBtn
        fullWidth
        data-cy={`decision-buy-dealer-game-no-${box.seatNumber}`}
        text={t('no')}
        onClick={() => sendBuyDealerGame(false)}
      />
      <Typography variant="head2" color="gold1" as="span">
        {t('buyGame')}?
      </Typography>
      <BlackSilverBtn
        fullWidth
        data-cy={`decision-buy-dealer-game-yes-${box.seatNumber}`}
        text={t('yes')}
        onClick={() => sendBuyDealerGame(true)}
      />
    </ContainerBuyGame>
  )
})

export default DecisionBuyDealerGame
